import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Size } from "../../Models/Size";
import { Color } from "../../Models/Color";
import { WishlistItem } from "../../Models/Wishlist";
import { Cart, CartItem } from "../../Models/Cartlist";


interface ShopProfile {
  shopProfileId: number;
  seller_type: string;
  seller_id: number;
  teamId: number;
  display_name: string;
  banner_url: string;
  logo_url: string;
  theme_color: string;
  is_active: boolean;
  created_by: number;
  updated_by: number | null;
  created_at: string;
  updated_at: string;
}

export interface globalvalues  {

    userDetails:any
    token : string
    activeMenue: string
    openSideMenue: boolean
    // playerInfo : any
    venderDetails: ShopProfile | null
    teamId : string | null
    allSizes: Size[]
    allColors : Color[]
    wishlist: WishlistItem[] | null
    cartlist: Cart | null
    activeStep: number
}

const initialState:globalvalues = {
    userDetails:null,
    token:"",
    activeMenue:"Dashboard",
    openSideMenue:false,
    venderDetails: null,
    // playerInfo: null
    teamId: null,
    allSizes : [],
    allColors: [],
    wishlist:[],
    cartlist:null,
    activeStep: 0

}
const globalSlice = createSlice({
    name:'global',
    initialState,
    reducers:{
        setToken(state,action:PayloadAction<string>){
            state.token = action.payload
        },
        setuserDetails(state,action:PayloadAction<any>){
            state.userDetails = action.payload
        },
        // setPlayerDetails(state,action:PayloadAction<any>){
        //     state.playerInfo = action.payload
        // },
        setActiveMenue(state,action:PayloadAction<string>){
            state.activeMenue = action.payload
        },
        setTeamId(state,action:PayloadAction<string>){
            state.teamId = action.payload
        },
        setOpenSideMenue(state,action:PayloadAction<boolean>){
            state.openSideMenue = action.payload
        },
        setVenderDetails(state,action:PayloadAction<ShopProfile>){
            state.venderDetails = action.payload
        },
        setAllSizes(state,action:PayloadAction<Size[]>){
            state.allSizes = action.payload
        },
        setAllColors(state,action:PayloadAction<Color[]>){
            state.allColors = action.payload
        },
        setWishList(state,action:PayloadAction<WishlistItem[] | null>){
            state.wishlist = action.payload
        },
        setCartList(state,action:PayloadAction<Cart | null>){
            state.cartlist = action.payload
        },
        setActiveStep(state,action:PayloadAction<number>){
            state.activeStep = action.payload
        },
    }

})
export const {setToken,setuserDetails,setActiveMenue,setOpenSideMenue,setVenderDetails,setTeamId, setAllColors, setAllSizes,setWishList, setCartList,setActiveStep} = globalSlice.actions
export default globalSlice.reducer 